// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://admin.parcelplus.com.au',
  pusher_key: 'ad4eeeb965a39626b139',
  pusher_cluster: 'ap4',
  socket_url: 'https://socket.fruitparcel.com.au',
  customerPortal: 'https://parcelplus.com.au',
  appUrl: 'https://parcelplus.com.au',
  booking2shipitUrl: 'https://2shipit.fruitparcel.com.au',
  googlemapkey: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
